import React from "react";
import { TooltipView } from "./view";
import { styles } from "./styles";

export class Tooltip extends React.Component {
  render() {
    return <TooltipView {...this.props} styles={styles} />;
  }
}
